module.exports = __webpack_public_path__ + "media/images/story/typo/greetingsMode-9c3f56c0e00fc85b9c9e8c5d2c7b529b.svg";